class UITeleport {
    static class_name = "teleport";
    static selector = '.' + UITeleport.class_name;
    static directions = {
        top_right    : 'top-right',
        top_middle   : 'top-middle',
        top_left     : 'top-left',

        right_bottom : 'right-bottom',
        right_middle : 'right-middle',
        right_top    : 'right-top',

        bottom_right : 'bottom-right',
        bottom_middle: 'bottom-middle',
        bottom_left  : 'bottom-left',

        left_bottom  : 'left-bottom',
        left_middle  : 'left-middle',
        left_top     : 'left-top'
    };

    directions = UITeleport.directions;

    /**
     * @param {Node} $target
     *
     * @param {Object} options
     * @param {Node}   options.$wrapper
     * @param {Node}   options.$content
     * 
     * @param {String} options.html
     * @param {Number} options.shift
     * @param {Number} options.indent
     * @param {Number} options.z_index
     * @param {String} options.class_name
     * @param {String} options.direction
     * @param {Number} options.animation_time
     *
     * @param {Function} options.onBeforeOpen
     * @param {Function} options.onOpen
     * @param {Function} options.onBeforeClose
     * @param {Function} options.onClose
     * */
    constructor($target, options) {
        const that = this;

        const { html, shift, indent, z_index, class_name, direction } = that.#getComputedOptions(options);

        // DOM
        that.$target = $target;
        that.$wrapper = getWrapper(html, class_name);

        // VARS
        that.shift          = shift;
        that.indent         = indent;
        that.z_index        = z_index;
        that.direction      = direction;
        that.animation_time = (options.animation_time > 0 ? options.animation_time : 350);

        //
        that.is_active = false;

        // Functions
        that.on = {
            beforeOpen: (typeof options.onBeforeOpen === 'function' ? options.onBeforeOpen : function() {}),
            open: (typeof options.onOpen === 'function' ? options.onOpen : function() {}),
            beforeClose: (typeof options.onBeforeClose === 'function' ? options.onBeforeClose : function() {}),
            close: (typeof options.onClose === 'function' ? options.onClose : function() {})
        };

        // Init
        that.#init();

        function getWrapper(html, class_name) {
            const $wrapper = $('<div class="'+ UITeleport.class_name +'"></div>').html(html);

            if (class_name) {
                $wrapper.addClass(class_name);
            }

            return $wrapper;
        }
    }

    show() {
        const that = this;

        if (that.is_active) { return false; }
        that.is_active = true;

        that.on.beforeOpen(that);

        that.$wrapper
            .css('visibility', 'hidden')
            .appendTo(document.body);

        setIndex(that.$wrapper);

        that.#setPosition();

        that.$wrapper
            .hide()
            .css('visibility', '')
            .addClass(['animated', 'faster', 'fadeIn'].join(' '))
            .show();

        setTimeout(function () {
            that.on.open(that);
        }, that.animation_time);

        function setIndex($wrapper) {
            let target_z_index = getTargetIndex();
            target_z_index = (target_z_index > 0 ? target_z_index : 0);

            let wrapper_z_index = parseInt($wrapper.css('z-index'));
            wrapper_z_index = (wrapper_z_index > 0 ? wrapper_z_index : 0);

            const z_index = Math.max(that.z_index, target_z_index, wrapper_z_index);
            if (z_index > 0 && z_index !== wrapper_z_index) {
                $wrapper.css('z-index', z_index);
            }

            that.z_index = z_index;

            /**
             * @description Ищем среди родителей элементы с zIndex выше минимального
             * @param {Number?} min_index
             * @return {Number}
             * */
            function getTargetIndex(min_index = 0) {
                const parents = getParents(that.$target[0]);

                return parents.reduce( function(index, node) {
                    const parent_index = parseFloat(window.getComputedStyle(node).zIndex);
                    return (parent_index > index ? parent_index : index);
                }, min_index);

                /**
                 * @param {Node} node
                 * @return {Array}
                 * */
                function getParents(node) {
                    let parents = [];

                    while (node) {
                        if (node !== document.body) {
                            parents.push(node);
                            node = node.parentNode;
                        } else {
                            node = null;
                        }
                    }

                    return parents;
                }
            }
        }
    };

    close() {
        const that = this;

        if (!that.is_active) { return false; }
        that.is_active = false;

        that.on.beforeClose(that);

        that.$wrapper
            .removeClass('fadeIn')
            .addClass('fadeOut');

        setTimeout(function () {
            that.$wrapper.remove();
            that.on.close(that);
        }, that.animation_time);
    };

    /**
     * @description Метод для обновления позиции
     * */
    resize() {
        const that = this;

        if (that.is_active) {
            that.#setPosition();
        }
    };

    #init() {
        const that = this;

        that.show();

        // Если внутри подсказки есть картинки (которые загрузятся после рендере)
        const $images = that.$wrapper.find("img");
        if ($images.length) {
            $images.on('load', function() {
                that.resize();
            });
        }

        that.$wrapper.on('click', '.js-teleport-close', function(event) {
            event.preventDefault();
            that.close();
        });

        that.$wrapper.on('teleport_resize', function() {
            that.resize();
        });

        that.$wrapper.data('teleport', that);
    };

    #getComputedOptions(options) {
        const that = this;

        let html       = '',
            width      = (options.width && options.width > 0 ? options.width : null),
            shift      = (options.shift && options.shift > 0 ? options.shift : 0),
            indent     = (options.indent && options.indent > 0 ? options.indent : 0),
            z_index    = (options.z_index && options.z_index > 0 ? options.z_index : 0),
            class_name = (options.class_name ? options.class_name : ''),
            direction  = that.directions.bottom_right;

        if (options.direction) {
            direction = options.direction;

        // Если направление не задано явно в параметрах options.direction
        // используем options.$wrapper, для определения направления через классы на нём
        } else if (options.$wrapper && options.$wrapper.length) {
            const $content_wrapper = options.$wrapper;

            if ($content_wrapper.hasClass('top-left')) {
                direction = that.directions.top_left;
            } else if ($content_wrapper.hasClass('top-middle')) {
                direction = that.directions.top_middle;
            } else if ($content_wrapper.hasClass('top-right')) {
                direction = that.directions.top_right;

            } else if ($content_wrapper.hasClass('right-bottom')) {
                direction = that.directions.right_bottom;
            } else if ($content_wrapper.hasClass('right-middle')) {
                direction = that.directions.right_middle;
            } else if ($content_wrapper.hasClass('right-top')) {
                direction = that.directions.right_top;

            } else if ($content_wrapper.hasClass('bottom-right')) {
                direction = that.directions.bottom_right;
            } else if ($content_wrapper.hasClass('bottom-middle')) {
                direction = that.directions.bottom_middle;
            } else if ($content_wrapper.hasClass('bottom-left')) {
                direction = that.directions.bottom_left;

            } else if ($content_wrapper.hasClass('left-bottom')) {
                direction = that.directions.left_bottom;
            } else if ($content_wrapper.hasClass('left-middle')) {
                direction = that.directions.left_middle;
            } else if ($content_wrapper.hasClass('left-top')) {
                direction = that.directions.left_top;
            }
        }

        if (options.html) {
            html = options.html;

        // Если контент не передан явно в options.html
        // клонируем DOM-контент переданный в параметре options.$content
        } else if (options.$content && options.$content.length) {
            const $content = options.$content;

            html = $content[0].outerHTML;

            if (!z_index) {
                const content_z_index = parseInt($content.css('z-index'));
                if (content_z_index > 0) {
                    z_index = content_z_index;
                }
            }

            const content_index = parseInt($content.data('index'));
            if (content_index > 0) {
                z_index = content_index;
            }

            const content_width = parseInt($content.data('width'));
            if (content_width > 0) {
                width = content_width;
            }

            const content_indent = parseInt($content.data('indent'));
            if (content_indent >= 0) {
                indent = content_indent;
            }

            const content_shift = parseInt($content.data('shift'));
            if (Math.abs(content_shift) >= 0) {
                shift = content_shift;
            }
        }

        if (!html) {
            $.sa.error('Содержимое подсказки не найдено');
        }

        return {
            html,
            shift,
            indent,
            z_index,
            class_name,
            direction
        };
    };

    #setPosition() {
        const that = this,
              $target = that.$target;

        // Хак, чтобы узнать реальные размеры после рендера
        that.$wrapper[0].offsetHeight;

        const scroll_top = document.documentElement.scrollTop,
              scroll_left = document.documentElement.scrollLeft,
              page_w = document.body.clientWidth,
              page_h = document.body.offsetHeight;

        const target_rect = $target[0].getBoundingClientRect(),
              target_left   = target_rect.left + scroll_left,
              target_top    = target_rect.top + scroll_top,
              target_w      = target_rect.width,
              target_h      = target_rect.height;

        const hint_rect = that.$wrapper[0].getBoundingClientRect(),
              hint_w = hint_rect.width,
              hint_h = hint_rect.height;

        const css = getCSS(that.direction, true);

        that.$wrapper.css(css);

        /**
         * @param {String} direction
         * @param {Boolean} protection
         * @return {Object}
         * */
        function getCSS(direction, protection = true) {
            const indent = that.indent,
                  shift = that.shift;

            let top, left;

            switch (direction) {
                case that.directions.top_right:
                    top  = target_top - hint_h - indent;
                    left = target_left + shift;
                    break;

                case that.directions.top_middle:
                    top  = target_top - hint_h - indent;
                    left = target_left + shift + (target_w/2) - (hint_w/2);
                    break;

                case that.directions.top_left:
                    top  = target_top - hint_h - indent;
                    left = target_left + shift + target_w - hint_w;
                    break;

                case that.directions.right_bottom:
                    top  = target_top + shift;
                    left = target_left + target_w + indent;
                    break;

                case that.directions.right_middle:
                    top  = target_top + shift + (target_h/2) - (hint_h/2);
                    left = target_left + target_w + indent;
                    break;

                case that.directions.right_top:
                    top  = target_top + shift + target_h - hint_h;
                    left = target_left + target_w + indent;
                    break;

                case that.directions.bottom_right:
                    top  = target_top + target_h + indent;
                    left = target_left + shift;
                    break;

                case that.directions.bottom_middle:
                    top  = target_top + target_h + indent;
                    left = target_left + shift + (target_w/2) - (hint_w/2);
                    break;

                case that.directions.bottom_left:
                    top  = target_top + target_h + indent;
                    left = target_left + shift + target_w - hint_w;
                    break;

                case that.directions.left_bottom:
                    top  = target_top + shift;
                    left = target_left - hint_w - indent;
                    break;

                case that.directions.left_middle:
                    top  = target_top + shift + (target_h/2) - (hint_h/2);
                    left = target_left - hint_w - indent;
                    break;

                case that.directions.left_top:
                    top  = target_top + shift + target_h - hint_h;
                    left = target_left - hint_w - indent;
                    break;

                default:
                    top  = target_top - hint_h - indent;
                    left = target_left + shift;
                    break;
            }

            let result = {
                top : parseInt(top),
                left: parseInt(left)
            };

            if (protection) {
                const protection_indent = 8;
                let new_direction = direction;

                if (top + hint_h + protection_indent > page_h) {
                    new_direction = new_direction.replace('bottom', 'top');
                } else if (top < protection_indent) {
                    new_direction = new_direction.replace('top', 'bottom');
                }

                if (left + hint_w + protection_indent> page_w) {
                    new_direction = new_direction.replace('right', 'left');
                } else if (left < protection_indent) {
                    new_direction = new_direction.replace('left', 'right');
                }

                if (new_direction !== direction) {
                    result = getCSS(new_direction, false);
                }
            }

            return result;
        }
    };
}